import React from 'react';
import InputMask from 'react-input-mask';
import * as S from '../common.styles';
import { BaseTextField } from './base-text-field';

interface TextFieldProps {
    value: any;
    readOnly?: boolean;
    dataTestId?: string;
    onChange?: (value: string) => void;
    error?: string;
    mask?: string;
    disabled?: boolean;
    maxLength?: number;
}

type WithLabelProp<T> = T & { label: string };

const TextField = ({
    readOnly,
    onChange,
    value,
    dataTestId,
    mask,
    disabled,
    maxLength,
}: TextFieldProps) => (
    readOnly
        ? <span data-testid={dataTestId}>{value}</span>
        : (
            <InputMask
                mask={mask}
                value={value}
                onChange={(event => onChange && onChange(event.target.value))}
                disabled={disabled}
                maxLength={maxLength}
            >
                <S.Input
                    data-testid={dataTestId}
                />
            </InputMask>
        )
);

export const TextFieldWithLabel = ({
    value,
    onChange,
    label,
    dataTestId,
    readOnly,
    error,
    mask,
    disabled,
    maxLength,
}: WithLabelProp<TextFieldProps>) => (
    <BaseTextField
        error={error}
        disabled={disabled}
    >
        <TextField
            dataTestId={dataTestId}
            readOnly={readOnly}
            value={value}
            onChange={onChange}
            mask={mask}
            disabled={disabled}
            maxLength={maxLength}
        />
        <S.Label>{label}</S.Label>
    </BaseTextField>
);
